import withAemIntegration from "../../../withAemIntegration";
import Cookies from 'js-cookie';
import CryptoJS from 'crypto-js';
// import env from '@lexus.com/ui/dist/utilities/env';

const ComponentEditConfig = {
    emptyLabel: "Login Redirect",
    isEmpty: function (props) {
        return !props || !props.title || props.title.trim().length < 1;
    },
};

const LoginRedirect = (props) => {

    const authConfig = {
        ...props.authConfig
    }

    const statePath = authConfig?.state || 'drivers';
    const base64URLEncode = (words) => {
        return CryptoJS.enc.Base64.stringify(words)
            .replace(/\+/g, "-")
            .replace(/\//g, "_")
            .replace(/=/g, "");
    };
    const isEmpty = (elementName) => {
        let typeOfElement = typeof elementName;
        if (
            elementName &&
            undefined !== elementName &&
            "undefined" !== elementName &&
            null !== elementName &&
            typeOfElement !== "undefined"
        ) {
            if (typeOfElement === "string") {
                return elementName.trim() === "";
            }
            if (typeOfElement === "object") {
                return Object.entries(elementName).length === 0 ? true : false;
            }
        } else {
            return true;
        }
    };
    const generateCodeVerifierChallenge = () => {
        try {
            const verifier = base64URLEncode(CryptoJS.lib.WordArray.random(50));
            const challenge = base64URLEncode(CryptoJS.SHA256(verifier));

            Cookies.remove("verifier", { path: "/", domain: authConfig.cookieDomain });
            Cookies.set('verifier', verifier, {path: "/", domain: authConfig.cookieDomain, secure: true});

            return {
                challenge: challenge,
                verifier: verifier,
            };
        } catch (error) {
            throw new Error(`Crypto Error: ${error}`);
        }
    };
    const getState = (urlExpections = [], defaultPage = "") => {
        if (isEmpty(document.referrer) || !(document.referrer?.includes('lexus.com') || document.referrer?.includes('localhost'))) {
            return window.btoa(defaultPage);
        } else {
            return urlExpections.some((url) => document.referrer.includes(url))
                ? window.btoa(defaultPage)
                : window.btoa(document.referrer);
        }
    };

    const pkceConstants = generateCodeVerifierChallenge();
    const state = getState([`/${statePath}/login`,`/${statePath}/register`,`/${statePath}/account/activate`,`/${statePath}/account/forgot-password`,`/${statePath}/account/verify-phone-number`, `/${statePath}/account/resend-activation-email`,`/${statePath}/account/create-account`,`/${statePath}/account/change-password`,`/${statePath}/account/verify-mobile`], `/${statePath}`)
    const code_challenge = pkceConstants.challenge;
    const loginUrl = props.authConfig.loginURL.replace('${code_challenge}', code_challenge).replace('${state}', state); // NOSONAR

    Cookies.remove("drivers-default-vehicle", { path: "/", domain: authConfig.cookieDomain });
    window.location = loginUrl;

    return <div></div>;
};

export default withAemIntegration("lexus/components/login/redirect")(LoginRedirect, ComponentEditConfig);
